import { render, staticRenderFns } from "./new-show-search.vue?vue&type=template&id=faa72bbc&scoped=true&"
import script from "./new-show-search.vue?vue&type=script&lang=js&"
export * from "./new-show-search.vue?vue&type=script&lang=js&"
import style0 from "./new-show-search.vue?vue&type=style&index=0&id=faa72bbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa72bbc",
  null
  
)

export default component.exports